window.soundEnabled = false;

export function toggleMusic() {
  const musicToggle = document.querySelector(".musicToggle");
  const musicIcon = musicToggle?.querySelector("img");

  if (!musicIcon) return;

  window.soundEnabled = !window.soundEnabled;

  if (window.soundEnabled) {
    musicIcon.src = "./assets/img/soundON.webp";
    musicIcon.alt = "Звук включен";

    if (typeof window.playBackgroundMusic === "function") {
      window.playBackgroundMusic();
    } else {
      console.log("playBackgroundMusic не найдена");
    }
  } else {
    musicIcon.src = "./assets/img/soundOFF.webp";
    musicIcon.alt = "Звук выключен";

    if (window.allAudioInstances) {
      window.allAudioInstances.forEach((audio) => {
        audio.pause();
        audio.currentTime = 0;
      });
    }
  }
}
